export const CONSTANT = {
  IV: 'cosbrowser-share',
};

export const config = {
  fileMaxSize: 512 * 1024 * 1024 * 1024,
  // fileMaxSize: 1 * 1024 * 1024,
};
